// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"36f7bb43","190":"e672416b","272":"b66f9e15","663":"c19513cf","733":"e63a0c49","791":"59f10a29"}[chunkId] + ".css";
};